import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";

import { RidesPageContent } from "./rides.page.content";

export const RidesPage: FC = () => {
  return (
    <PageContextWrapper entity="ride">
      <RidesPageContent />
    </PageContextWrapper>
  );
};
